/* ==========================================================================
   Woves — cart drawer "Complete your order" row.
   Fetches sections/cart-upsells (rendered for THIS market: prices, language)
   into [data-cu-host]: Shopify's related products for the first cart line,
   topped up with the curated list. Products already in the cart are hidden.
   A variant pick swaps the card's photo, price and compare-at (strings rendered
   by Liquid); "Add" posts to /cart/add.js and asks theme.js to repaint the
   drawer (window.WoveSyncCart), so the drawer stays open and nothing jumps.
   theme.js is not touched: this file only listens.
   ========================================================================== */
(function () {
  'use strict';
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init() {
    var drawer = document.querySelector('.cart-drawer');
    var host = drawer && drawer.querySelector('[data-cu-host]');
    var items = drawer && drawer.querySelector('.cart-drawer__items');
    if (!host || !items) return;

    var cache = {};          // url -> html
    var loadedFor = null;    // product id the row was built for ('' = curated only)
    var inCart = {};         // product id -> true
    var busy = false, again = false, timer = null;

    function get(url) {
      if (cache[url]) return Promise.resolve(cache[url]);
      return fetch(url, { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (t) { cache[url] = t; return t; })
        .catch(function () { return ''; });
    }
    function block(html) {
      var tmp = document.createElement('div');
      tmp.innerHTML = html || '';
      return tmp.querySelector('[data-cu]');
    }
    function build(pid) {
      var rec = ROOT + 'recommendations/products?section_id=cart-upsells&limit=10&intent=related&product_id=' + pid;
      var cur = ROOT + '?section_id=cart-upsells';
      var first = pid ? get(rec) : get(cur);
      return first.then(function (html) {
        var b = block(html);
        if (b || !pid) return b;
        return get(cur).then(block);
      });
    }
    function paint(b) {
      host.innerHTML = '';
      if (!b) return;
      if (!reduce) b.classList.add('is-in');
      host.appendChild(b);
      wire(b);
    }
    function hideInCart(animate) {
      var b = host.querySelector('[data-cu]');
      if (!b) return;
      var left = 0;
      Array.prototype.forEach.call(b.querySelectorAll('[data-cu-card]'), function (c) {
        var hit = !!inCart[c.getAttribute('data-product-id')];
        if (hit && !c.hidden) {
          if (animate && !reduce) {
            c.classList.add('is-leaving');
            setTimeout(function () { c.hidden = true; c.classList.remove('is-leaving'); syncArrows(b); }, 260);
          } else c.hidden = true;
        } else if (!hit && c.hidden) { c.hidden = false; }
        if (!hit) left++;
      });
      b.hidden = left === 0;
      syncArrows(b);
    }

    function refresh(animate) {
      if (busy) { again = true; return; }
      busy = true;
      fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          inCart = {};
          var pid = '';
          (cart.items || []).forEach(function (it) {
            inCart[String(it.product_id)] = true;
          });
          // Stay anchored to the product the row was built for while it is still in
          // the cart, so adding a suggestion never reshuffles the row under the thumb.
          if (loadedFor && inCart[loadedFor]) pid = loadedFor;
          else {
            var items = (cart.items || []).slice().reverse(); // oldest line first
            for (var i = 0; i < items.length; i++) if (items[i].final_line_price > 0) { pid = String(items[i].product_id); break; }
          }
          if (pid === loadedFor && host.querySelector('[data-cu]')) { hideInCart(animate); return; }
          return build(pid).then(function (b) {
            // A newer cart state may have arrived meanwhile; keep the latest only.
            loadedFor = pid;
            paint(b);
            hideInCart(false);
          });
        })
        .catch(function () {})
        .then(function () {
          busy = false;
          if (again) { again = false; refresh(animate); }
        });
    }
    function soon(animate) {
      clearTimeout(timer);
      timer = setTimeout(function () { refresh(animate); }, 120);
    }

    /* ---- a card: variant pick + add ---- */
    function wire(b) {
      var S = {};
      try { S = JSON.parse(b.querySelector('[data-cu-strings]').textContent); } catch (e) {}
      var track = b.querySelector('[data-cu-track]');

      b.addEventListener('change', function (e) {
        var sel = e.target.closest('[data-cu-select]');
        if (!sel) return;
        var card = sel.closest('[data-cu-card]');
        var o = sel.options[sel.selectedIndex];
        if (!card || !o) return;
        var now = card.querySelector('[data-cu-now]'), was = card.querySelector('[data-cu-was]');
        var off = card.querySelector('[data-cu-off]'), img = card.querySelector('[data-cu-img]');
        var add = card.querySelector('[data-cu-add]');
        if (now) now.textContent = o.getAttribute('data-now') || '';
        if (was) { var w = o.getAttribute('data-was') || ''; was.textContent = w; was.hidden = !w; }
        if (off) { var p = parseInt(o.getAttribute('data-off'), 10) || 0; off.textContent = '−' + p + '%'; off.hidden = !p; }
        if (add) add.setAttribute('data-variant', o.value);
        var src = o.getAttribute('data-img');
        if (img && src && img.getAttribute('src') !== src) {
          if (reduce) { img.removeAttribute('srcset'); img.src = src; }
          else {
            img.classList.add('is-swap');
            var pre = new Image();
            pre.onload = pre.onerror = function () { img.removeAttribute('srcset'); img.src = src; img.classList.remove('is-swap'); };
            pre.src = src;
          }
        }
      });

      b.addEventListener('click', function (e) {
        if (e.target.closest('[data-cu-prev]')) { track.scrollBy({ left: -step(track), behavior: reduce ? 'auto' : 'smooth' }); return; }
        if (e.target.closest('[data-cu-next]')) { track.scrollBy({ left: step(track), behavior: reduce ? 'auto' : 'smooth' }); return; }
        var btn = e.target.closest('[data-cu-add]');
        if (!btn || btn.disabled) return;
        var id = parseInt(btn.getAttribute('data-variant'), 10);
        if (!id) return;
        var label = btn.querySelector('span');
        var original = label ? label.textContent : '';
        btn.disabled = true;
        fetch(ROOT + 'cart/add.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
        })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error((res.j && res.j.description) || 'add');
            if (label) label.textContent = S.added || original;
            btn.classList.add('is-done');
            if (window.fbq) try { window.fbq('track', 'AddToCart'); } catch (err) {}
            // theme.js repaints the lines; the observer below then hides this card.
            setTimeout(function () { if (window.WoveSyncCart) window.WoveSyncCart(); else soon(true); }, 450);
          })
          .catch(function () {
            if (label) label.textContent = S.soldOut || original;
            setTimeout(function () { if (label) label.textContent = original; btn.disabled = false; }, 1600);
          });
      });

      if (track) {
        track.addEventListener('scroll', function () { syncArrows(b); }, { passive: true });
        syncArrows(b);
      }
    }
    function step(track) {
      var c = track.querySelector('[data-cu-card]:not([hidden])');
      return c ? (c.getBoundingClientRect().width + 10) * 2 : track.clientWidth * .8;
    }
    function syncArrows(b) {
      var track = b.querySelector('[data-cu-track]');
      var prev = b.querySelector('[data-cu-prev]'), next = b.querySelector('[data-cu-next]');
      if (!track || !prev || !next) return;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    }

    /* ---- when to refresh ---- */
    // theme.js repaints .cart-drawer__items on every add / qty change / remove.
    new MutationObserver(function () { soon(true); }).observe(items, { childList: true });
    // Opening the drawer: make sure the row is there.
    new MutationObserver(function () {
      if (drawer.classList.contains('is-open') && !host.querySelector('[data-cu]')) soon(false);
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    // Warm up once the page is idle, so the first open is instant.
    (window.requestIdleCallback || function (f) { return setTimeout(f, 1500); })(function () { refresh(false); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
